<div class="d-flex align-items-center justify-content-between mb-4 mx-xl-3">
    <h6 class="montserrat-medium text-gray-500">Add your media</h6>

    <div style="display: flex; flex-direction: column; gap: 5px; width: 220px">
        <button class="btn btn-lg btn-gray-500" [disabled]="checkFieldsValidation()" (click)="navigateNextStep()"
            *ngIf="!previewMode || editMode">
            proceed
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        </button>
        <button class="btn btn-lg btn-gray-500" [disabled]="shouldNotSaveCampaign()" (click)="saveCampaign()"
            *ngIf="!previewMode || editMode">
            Save
        </button>
        <div style="display: flex; flex-direction: row; gap: 5px; align-items: center">
            <mat-form-field class="form-group dark-input"
                [ngStyle]="{ display: !isValidNumberOfVisuals() ? 'none' : 'block' }">
                <mat-label>Download Media Plan</mat-label>
                <mat-select [(ngModel)]="selectedFileType" (selectionChange)="onFileTypeSelect($event.value)"
                    [disabled]="loading" class="multiline-mat-select" panelClass="select-panel-down sided-select">
                    <mat-option value="excel" class="text-capitalize multiline-mat-option">Excel</mat-option>
                    <mat-option value="pdf" class="text-capitalize multiline-mat-option">PDF</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        </div>
    </div>
</div>

<div class="text-center pt-4 spinner-wrapper" *ngIf="uploadingMedia">
    <div class="spinner-content">
        <mat-spinner style="margin: 0 auto"></mat-spinner>
        <br />
        <span>Uploading media, please wait...</span>
    </div>
</div>
<app-highlights *ngIf="campaign" [step]="4" [campaign]="campaign"></app-highlights>
<mat-form-field class="form-group dark-input" style="width: 20%; margin-bottom: 1%; margin-left: 1%">
    <input matInput type="number" [ngModel]="numberOfVisuals"
        [disabled]="previewMode || partialEditMode || liveEditMode" (ngModelChange)="updateNumberOfVisuals($event)"
        placeholder="How many visuals?" />
</mat-form-field>

<mat-form-field *ngIf="editMode || partialEditMode || liveEditMode" class="form-group dark-input"
    style="width: 20%; margin-bottom: 1%; margin-left: 1%">
    <input matInput type="number" [ngModel]="newNumberOfVisuals" (ngModelChange)="updateNewNumberOfVisuals($event)"
        placeholder="How many visuals you want to add?" />
</mat-form-field>

<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1 mx-xl-3">
        <div class="bg-gray-200 p-3 br-15 mb-4" *ngFor="let mediaObj of mediasList; let resIndex = index">
            <div class="resolution-label">
                <span>{{ mediaObj.resolution }}</span>
            </div>
            <form name="form" *ngFor="let subMedia of mediaObj.subMedias; let subMediaIdx = index" class="mt-3">
                <div class="row">
                    <div style="flex-direction: column; gap: 10px"
                        class="col-1 d-flex justify-content-center align-items-center p-0">
                        <app-channel-status-color-coding *ngIf="showChannelStatusDistinction()"
                            [currentChannelStatus]="getChannelStatusForMedia(subMedia)"></app-channel-status-color-coding>
                        <a *ngIf="subMediaIdx != 0" (click)="removeSubMedia(resIndex, subMediaIdx)" [ngClass]="{
                                'disabled bg': disableMediaButton(subMedia.status)
                            }"
                            class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
                            <h6 class="text-white">-</h6>
                        </a>
                        <a *ngIf="
                                (!previewMode && subMedia.status == 'APPROVED') ||
                                (isPreviewModeAndEditMode && subMedia.status == 'APPROVED')
                            " (click)="pauseCampaignVisual(subMedia)"
                            class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
                            <mat-icon style="font-size: medium; padding-top: 4px" class="text-white">pause</mat-icon>
                        </a>
                    </div>

                    <div class="col-4 pl-0">
                        <div class="upload-img position-relative border border-gray-500 br-15 w-100 h-100" [ngClass]="{
                                validationError: isFormSubmitted && subMedia.asset == null
                            }">
                            <div class="paused-status-tag" *ngIf="subMedia.status == 'PAUSED'">
                                <h6 class="text-white">PAUSED</h6>
                            </div>

                            <div class="overlay position-absolute w-100 h-100 br-15" *ngIf="subMedia.asset"></div>
                            <div class="text-center">
                                <div [ngSwitch]="getChannelType(mediaObj.idChannel)">
                                    <ng-container *ngSwitchCase="'isNotMultiRes'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-x" type="file"
                                            class="d-none" required (change)="
                                                onImgFileChange(
                                                    $event,
                                                    resIndex,
                                                    subMediaIdx,
                                                    mediaObj.resolution
                                                )
                                            " [attr.disabled]="
                                                disableMediaButton(subMedia) ? '' : null
                                            " />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'isMultiScreensAsOne'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-x" type="button"
                                            class="d-none" required (click)="
                                                openUploadMediaDialog(
                                                    mediaObj.idChannel,
                                                    subMedia,
                                                    subMediaIdx,
                                                    resIndex,
                                                    'upload',
                                                    'isMultiScreensAsOne'
                                                )
                                            " [attr.disabled]="
                                                disableMediaButton(subMedia) ? '' : null
                                            " />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'isMultiRes'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-x" type="button"
                                            class="d-none" required (click)="
                                                openUploadMediaDialog(
                                                    mediaObj.idChannel,
                                                    subMedia,
                                                    subMediaIdx,
                                                    resIndex,
                                                    'upload',
                                                    'isMultiRes'
                                                )
                                            " [attr.disabled]="
                                                disableMediaButton(subMedia) ? '' : null
                                            " />
                                    </ng-container>
                                </div>

                                <label *ngIf="hideUploadMedia(subMedia.status)"
                                    for="imgFile-{{ resIndex }}-{{ subMediaIdx }}-x" class="img-btn">
                                    <span href="javascript:;" [ngClass]="{
                                            'disabled bg': disableMediaButton(subMedia.status)
                                        }"
                                        class="d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto">
                                        <img src="./assets/images/icons/common/plus.svg" alt="Upload media"
                                            title="Upload media" />
                                    </span>
                                    <span class="d-block text-center monserrat-medium mt-2">Upload media</span>
                                </label>
                            </div>
                            <div class="text-center" *ngIf="
                                    subMedia.asset.length > 0 &&
                                    previewMode &&
                                    !isClient() &&
                                    !isPreviewModeAndEditMode()
                                ">
                                <div [ngSwitch]="getChannelType(mediaObj.idChannel)">
                                    <ng-container *ngSwitchCase="'isNotMultiRes'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-xd" type="button"
                                            class="d-none" required
                                            (click)="downloadMedia(subMedia.asset[0]?.fileName)" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'isMultiScreensAsOne'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-xd" type="button"
                                            class="d-none" required
                                            (click)="downloadMedia(subMedia.asset[0]?.fileName)" />
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'isMultiRes'">
                                        <input id="imgFile-{{ resIndex }}-{{ subMediaIdx }}-xd" type="button"
                                            class="d-none" required (click)="
                                                openUploadMediaDialog(
                                                    mediaObj.idChannel,
                                                    subMedia,
                                                    subMediaIdx,
                                                    resIndex,
                                                    'download',
                                                    'isMultiRes'
                                                )
                                            " />
                                    </ng-container>
                                </div>
                                <label for="imgFile-{{ resIndex }}-{{ subMediaIdx }}-xd" class="img-btn">
                                    <span href="javascript:;"
                                        class="d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto">
                                        <img src="./assets/images/icons/common/arrow-down.svg" alt="Download media"
                                            title="Download media" />
                                    </span>
                                    <span class="d-block text-center monserrat-medium mt-2">Download media</span>
                                </label>
                            </div>
                            <ng-container *ngIf="subMedia.asset">
                                <div class="text-center d-flex align-items-center justify-content-center h-100">
                                    <!-- Video is decided on first, by file type, so the card looks the same
                                         every time; branching on the thumbnail first was what made a video
                                         sometimes appear as a still and sometimes as a player. No `controls`
                                         here: the grid is a preview, so it shows the poster frame (or the
                                         first frame) with no player chrome. Playback lives in the upload
                                         dialog, which does keep controls. -->
                                    <ng-container *ngIf="isVideo(subMedia.asset[0]?.fileName); else stillBlock">
                                        <video
                                            [src]="mediaUrl + '/iintegration/media/' + subMedia.asset[0]?.fileName"
                                            [poster]="
                                                subMedia.asset[0]?.thumbnail
                                                    ? mediaUrl + '/iintegration/media/' + subMedia.asset[0]?.thumbnail
                                                    : null
                                            " class="img-fluid br-15 media-preview" preload="metadata"
                                            disablePictureInPicture>
                                        </video>
                                    </ng-container>
                                    <ng-template #stillBlock>
                                        <ng-container *ngIf="subMedia.asset[0]?.thumbnail; else imageBlock">
                                            <img [src]="mediaUrl + '/iintegration/media/' + subMedia.asset[0]?.thumbnail"
                                                class="img-fluid br-15 media-preview" />
                                        </ng-container>
                                        <ng-template #imageBlock>
                                            <ng-container *ngIf="subMedia.asset[0]?.fileName">
                                                <img [src]="
                                                        mediaUrl +
                                                        '/iintegration/media/' +
                                                        subMedia.asset[0]?.fileName
                                                    " (show)="(subMedia.asset && subMedia.asset.length > 0)"
                                                    class="img-fluid br-15 media-preview" />
                                            </ng-container>
                                        </ng-template>
                                    </ng-template>
                                </div>
                            </ng-container>
                        </div>
                        <mat-error *ngIf="isFormSubmitted && subMedia.asset == null">Media file is required</mat-error>
                    </div>

                    <div class="col-7">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <mat-form-field class="form-group dark-input" [ngClass]="{
                                        validationError:
                                            isFormSubmitted &&
                                            mediaTitle.invalid &&
                                            (mediaTitle.dirty || mediaTitle.touched)
                                    }">
                                    <input matInput type="text" #mediaTitle="ngModel"
                                        [disabled]="disableMediaButton(subMedia.status)" name="mediaTitle"
                                        (ngModelChange)="mediaTitle.control.markAsTouched()" placeholder="Media title"
                                        [(ngModel)]="subMedia.title" [ngModelOptions]="{ standalone: true }" required />
                                </mat-form-field>
                                <mat-error *ngIf="
                                        isFormSubmitted &&
                                        mediaTitle.invalid &&
                                        (mediaTitle.dirty || mediaTitle.touched)
                                    ">Media title is required</mat-error>
                            </div>
                            <div class="col-12 d-xl-flex justify-content-between align-items-start mb-4">
                                <p class="mb-0">
                                    <span class="text-gray mr-5">Set Your channels list and include a specific rule for
                                        each
                                        one of them.</span>
                                    <br />
                                    <small><i>Please make sure you visual contains Arabic and English
                                            Text
                                            <a href="assets/files/Visual%20for%20Approval%20Municipality%20regulation.pdf"
                                                download>
                                                <mat-icon class="info-icon">{{ 'info' }}</mat-icon>
                                            </a>
                                        </i></small>
                                </p>
                                <div class="d-flex align-items-center justify-content-between flex-grow-1">
                                    <button class="small-action-btn bg-gray-500 text-primary"
                                        (click)="addChannel(resIndex, subMediaIdx)" [ngClass]="{
                                            'disabled bg': disableMediaButton(subMedia.status)
                                        }" [disabled]="disableMediaButton(subMedia.status)" [hidden]="
                                            getChannelsByResolutionKey(mediaObj.resolution)
                                                .length == subMedia.mediaChannels.length
                                        ">
                                        <img src="./assets/images/icons/common/plus.svg" alt="Add Channel"
                                            title="Add Channel" />
                                    </button>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row" *ngFor="
                                        let channel of subMedia.mediaChannels;
                                        let channelIdx = index
                                    ">
                                    <div class="col-xl-1 d-flex align-items-center justify-content-center p-0">
                                        <a (click)="
                                                removeChannel(resIndex, subMediaIdx, channelIdx)
                                            " [ngClass]="{
                                                'disabled bg': disableMediaButton(subMedia.status)
                                            }"
                                            class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary">
                                            <h6 class="text-white">-</h6>
                                        </a>
                                    </div>
                                    <div class="col-xl-6">
                                        <mat-form-field class="form-group dark-input">
                                            <mat-label>Channel</mat-label>
                                            <mat-select [(ngModel)]="channel.channelId" class="multiline-mat-select"
                                                [ngModelOptions]="{ standalone: true }"
                                                [disabled]="disableMediaButton(subMedia.status)"
                                                panelClass="select-panel-down sided-select"
                                                [disableOptionCentering]="true" (selectionChange)="
                                                    onChangeChannel(
                                                        resIndex,
                                                        subMediaIdx,
                                                        channelIdx,
                                                        mediaObj.resolution,
                                                        channel.channelId
                                                    )
                                                ">
                                                <mat-option *ngFor="
                                                        let channelInfo of getChannelsByResolutionKey(
                                                            mediaObj.resolution
                                                        )
                                                    " [value]="channelInfo.idChannel" [disabled]="
                                                        validateOnlyOneChannelPerMedia(
                                                            resIndex,
                                                            subMediaIdx,
                                                            channelInfo.idChannel
                                                        )
                                                    " class="text-capitalize multiline-mat-option">
                                                    <span class="long-span-channel">{{
                                                        channelInfo.name
                                                        }}</span>
                                                    <span style="float: right; color: gray">
                                                        <small>
                                                            -
                                                            {{
                                                            channelInfo.groups[0].loopDuration /
                                                            channelInfo.groups[0]
                                                            .nbrSlotsPerLoop | number
                                                            }}
                                                            seconds</small></span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-5">
                                        <mat-form-field class="form-group dark-input">
                                            <mat-label>Rule</mat-label>
                                            <mat-select (selectionChange)="
                                                    onChangeRule(
                                                        resIndex,
                                                        subMediaIdx,
                                                        channelIdx,
                                                        $event
                                                    )
                                                " [disabled]="
                                                    channel.channelId == '' ||
                                                    disableMediaButton(subMedia.status)
                                                " [(value)]="
                                                    rulesArrayValues[resIndex].rules[subMediaIdx][
                                                        channelIdx
                                                    ]
                                                " panelClass="select-panel-down" [disableOptionCentering]="true">
                                                <mat-option [disabled]="
                                                        validateGenericRule(
                                                            resIndex,
                                                            subMediaIdx,
                                                            channel.channelId,
                                                            channelIdx,
                                                            rule
                                                        )
                                                    " *ngFor="
                                                        let rule of getRulesByChannelIdAndResolution(
                                                            mediaObj.resolution,
                                                            channel.channelId
                                                        )
                                                    " [value]="rule" class="text-capitalize">
                                                    <span *ngIf="rule.value == -1">{{
                                                        rule.ruleName
                                                        }}</span>
                                                    <span *ngIf="rule.value != -1">{{
                                                        rule.ruleName +
                                                        ' ' +
                                                        rule.ruleOperatorEnum +
                                                        ' ' +
                                                        rule.value
                                                        }}</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row mt-4 pl-3">
                <a class="text-gray-500 montserrat-semi-bold d-inline-block" (click)="addSubMedia(resIndex)" [ngClass]="{
                        'disabled grayout': previewMode && !editMode
                    }">
                    <span class="d-flex align-items-center">
                        <img src="./assets/images/icons/common/plus-dark.svg" alt="Add Channel" title="Add Channel"
                            width="10" class="mr-2" />
                        <span>Add more</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
<app-file-uploader *ngIf="!previewMode" [documentsSizes]="documentsSizes" [editMode]="editMode"
    [previewMode]="previewMode" [hasExceededMaxFileSize]="hasExceededMaxFileSize" [title]="uploadFilesTitle"
    [subTitles]="subTitles" [acceptedFormats]="acceptedFormats" [maxFileSize]="maxFileSize"
    [onFileSelected]="onDocumentsSelected" [removePreviousFile]="removePreviousFile" [removeFile]="removeFile"
    [previousFiles]="previousFiles" [selectedFiles]="selectedFiles"></app-file-uploader>

<div *ngIf="previewMode">
    <span>Supporting documents (Trade License, D.E.D Permit, ...)</span>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 5px; margin-top: 10px">
        <div *ngFor="let file of previousFiles; let i = index" style="
                background-color: #fde150;
                width: fit-content;
                cursor: pointer;
                border-radius: 10px;
                padding: 10px;
                position: relative;
            " (click)="downloadDocument(file.title)">
            {{ file.title.split('_')[1] }}

            <a *ngIf="!previewMode"
                class="remove-btn d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary"
                style="position: absolute; top: -5px; right: -5px; height: 2rem; width: 2rem"
                (click)="removePreviousFile(i)">
                <h6 class="text-white">x</h6>
            </a>
        </div>
    </div>
</div>

<div class="d-flex align-items-center justify-content-end mt-1 mb-4 mx-xl-3">
    <button class="btn btn-lg btn-gray-500" [disabled]="checkFieldsValidation()" (click)="navigateNextStep()"
        *ngIf="!previewMode || (previewMode && editMode)">
        proceed
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
</div>

<ng-template #uploadImageDialog let-data>
    <div class="fixActionRow">
        <h2 class="montserrat-light text-gray-500 text-capitalize" mat-dialog-title
            *ngIf="data.actionType == 'upload' && !data.multiScreenChannel">
            Upload Medias
        </h2>
        <h2 class="montserrat-light text-gray-500 text-capitalize" mat-dialog-title
            *ngIf="data.actionType == 'download' && !data.multiScreenChannel">
            Download Medias
        </h2>
        <mat-dialog-content>
            <div class="mb-4" *ngIf="data.multiScreenChannel">
                <p>{{ data.multiScreenChannel.multiscreensAsOneImageDescription
                    || data.multiScreenChannel.multiScreensAsOneDescription }}</p>
                <img [src]="data.multiScreenChannel.multiScreensAsOneImage" class="img-fluid br-15" />
            </div>
            <div class="row">
                <div class="mb-1 col-6 pr-1 pl-1"
                    *ngFor="let resolution of data.multiResolution; let multiResIndex = index">
                    <div class="bg-gray-200 br-15 pt-1 pb-3">
                        <div class="resolution-label">
                            <span>{{ resolution.width + 'x' + resolution.height }}</span>
                        </div>
                        <div class="upload-img position-relative border border-gray-500 br-15 mr-2 ml-2" [ngClass]="{
                                validationError: isFormSubmitted && data.subMedia.asset == null
                            }">
                            <div class="overlay position-absolute w-100 h-100 br-15"
                                *ngIf="getAssetByIdGroup(data.subMedia.asset, resolution.idGroup)"></div>
                            <div class="text-center" *ngIf="data.actionType == 'upload'">
                                <input id="imgFile-{{ multiResIndex }}-{{ data.resIdx }}" type="file" class="d-none"
                                    required (change)="
                                        onImgFileChange(
                                            $event,
                                            data.resIdx,
                                            data.subMediaIdx,
                                            resolution.width + 'x' + resolution.height,
                                            resolution.idGroup,
                                            data.subMedia
                                        )
                                    " [attr.disabled]="disableMediaButton(data.subMedia) ? '' : null" />
                                <label for="imgFile-{{ multiResIndex }}-{{ data.resIdx }}" class="img-btn">
                                    <span href="javascript:;" [ngClass]="{
                                            'disabled bg':
                                                campaign &&
                                                campaign.wasPublished &&
                                                previewMode &&
                                                !editMode
                                        }"
                                        class="d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto">
                                        <img src="./assets/images/icons/common/plus.svg" alt="Upload media"
                                            title="Upload media" />
                                    </span>
                                    <span class="d-block text-center monserrat-medium mt-2">Upload media</span>
                                </label>
                            </div>
                            <div class="text-center" *ngIf="
                                    data.actionType == 'download' &&
                                    getAssetByIdGroup(data.subMedia.asset, resolution.idGroup) !=
                                        null
                                ">
                                <input id="imgFile-{{ multiResIndex }}-{{ data.resIdx }}" type="button" class="d-none"
                                    required (click)="
                                        downloadMedia(
                                            getAssetByIdGroup(
                                                data.subMedia.asset,
                                                resolution.idGroup
                                            )
                                        )
                                    " />
                                <label for="imgFile-{{ multiResIndex }}-{{ data.resIdx }}" class="img-btn">
                                    <span href="javascript:;"
                                        class="d-flex align-items-center justify-content-center text-center small-action-btn bg-gray-500 text-primary m-auto">
                                        <img src="./assets/images/icons/common/arrow-down.svg" alt="Download media"
                                            title="Download media" />
                                    </span>
                                    <span class="d-block text-center monserrat-medium mt-2">Download media</span>
                                </label>
                            </div>
                            <ng-container *ngIf="getAssetByIdGroup(data.subMedia.asset, resolution.idGroup) as assetFile">
                                <div class="text-center d-flex align-items-center justify-content-center h-100">
                                    <!-- Same type check as the grid: an <img> pointed at an mp4
                                         rendered as a broken-image icon. -->
                                    <video *ngIf="isVideo(assetFile); else dialogImage"
                                        [src]="mediaUrl + '/iintegration/media/' + assetFile"
                                        class="img-fluid br-15 media-preview" preload="metadata"
                                        disablePictureInPicture></video>
                                    <ng-template #dialogImage>
                                        <img [src]="mediaUrl + '/iintegration/media/' + assetFile"
                                            class="img-fluid br-15 media-preview" />
                                    </ng-template>
                                </div>
                            </ng-container>
                        </div>
                        <mat-error *ngIf="isFormSubmitted && data.subMedia.asset == null">Media file is
                            required</mat-error>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <div class="spacer-dialog"></div>
        <mat-dialog-actions>
            <button mat-button mat-dialog-close>CLOSE</button>
        </mat-dialog-actions>
    </div>
</ng-template>